module.exports = __webpack_public_path__ + "media/images/thumbs/anatomyphysiology/aq643-aa049a5ed6e37e4e1bcdcf906b169856.jpg";